import { EntityModel } from '@/interfaces'
import {
  ALL_CONTACT_BLOCK_SETTINGS_QUERY,
  CREATE_CONTACT_BLOCK_SETTINGS_MUTATION,
  DELETE_CONTACT_BLOCK_SETTINGS_MUTATION,
  FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION,
  SINGLE_CONTACT_BLOCK_SETTINGS_QUERY,
  UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION,
} from './graphql'

const cmsContactBlockSettingsModel: EntityModel = {
  name: 'contactBlockSettings',
  namePlural: 'contactBlockSettings',
  uniqueName: 'cmsContactBlockSettings',
  uniqueNamePlural: 'cmsContactBlockSettings',
  path: 'cms/config/contact_block_settings',
  baseUrl: '/cms/config/contact_block_settings',
  translationPrefix: 'entities:cmsContactBlockSettings.',
  getDisplayName: (values: any) => {
    return 'CMS Contact Block Settings'
  },
  gql: {
    getAll: ALL_CONTACT_BLOCK_SETTINGS_QUERY,
    getSingle: SINGLE_CONTACT_BLOCK_SETTINGS_QUERY,
    create: CREATE_CONTACT_BLOCK_SETTINGS_MUTATION,
    update: UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION,
    delete: DELETE_CONTACT_BLOCK_SETTINGS_MUTATION,
    forceDelete: FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION,
  },
  attributes: {
    slogan: {
      name: 'slogan',
      label: 'entities:cmsContactBlockSettings.attributes.slogan.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    title: {
      name: 'title',
      label: 'entities:cmsContactBlockSettings.attributes.title.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    text: {
      name: 'text',
      label: 'entities:cmsContactBlockSettings.attributes.text.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'textarea',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    phonePrefix: {
      name: 'phonePrefix',
      label: 'entities:cmsContactBlockSettings.attributes.phonePrefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    phone: {
      name: 'phone',
      label: 'entities:cmsContactBlockSettings.attributes.phone.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    phone2Prefix: {
      name: 'phone2Prefix',
      label: 'entities:cmsContactBlockSettings.attributes.phone2Prefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    phone2: {
      name: 'phone2',
      label: 'entities:cmsContactBlockSettings.attributes.phone2.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    openingHours1: {
      name: 'openingHours1',
      label: 'entities:cmsContactBlockSettings.attributes.openingHours1.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    openingHours2: {
      name: 'openingHours2',
      label: 'entities:cmsContactBlockSettings.attributes.openingHours2.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    email: {
      name: 'email',
      label: 'entities:cmsContactBlockSettings.attributes.email.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'email',
        },
      ],
    },
  },
}

export default cmsContactBlockSettingsModel
